import * as yupResolver from '@hookform/resolvers/yup';
import * as reactHookForm from 'react-hook-form';
import * as yup from 'yup';

const {
  useForm,
  useWatch,
  useFormContext,
  useFormState,
  useController,
  useFieldArray,
  FormProvider,
} = reactHookForm;

export type {
  UseFieldArrayReturn,
  UseFormGetValues,
  FieldArrayWithId,
  UseFormGetFieldState,
  UseFormSetValue,
  UseFormWatch,
  UseFormTrigger,
  FormState,
  UseFormReset,
  UseFormHandleSubmit,
  UseFormReturn,
  UseFormClearErrors,
  FieldPath,
  FieldValues,
  FieldErrors,
} from 'react-hook-form';

export {
  reactHookForm,
  useForm,
  useWatch,
  useFormContext,
  useFormState,
  useController,
  useFieldArray,
  FormProvider,
  yup,
  yupResolver,
};

export * from './components';
export * from './hooks';
